import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Kraljic positions (BP-10, SRM) — a supplier's position on the supply-risk x profit-impact matrix and
 * its derived quadrant. Lean first cut: risk + impact (0..100), segment, rationale, referencing the
 * supplier + category masters by ID. Shapes shared by the API (validation) and the web app (types).
 */
export const kraljicSegmentSchema = z.enum(['strategic', 'leverage', 'bottleneck', 'routine']);
export const kraljicPositionSchema = z.object({
    id: uuidSchema,
    supplierId: uuidSchema,
    categoryId: uuidSchema.nullable(),
    supplyRisk: z.number(),
    profitImpact: z.number(),
    segment: kraljicSegmentSchema,
    rationale: z.string().nullable(),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /kraljic/positions — place a supplier on the matrix (source 'manual'). */
export const createKraljicPositionSchema = z
    .object({
    supplierId: uuidSchema,
    categoryId: uuidSchema.optional(),
    supplyRisk: z.number().min(0).max(100).optional(),
    profitImpact: z.number().min(0).max(100).optional(),
    segment: kraljicSegmentSchema.optional(),
    rationale: z.string().trim().max(500).optional(),
})
    .strict();
/** PATCH /kraljic/positions/:id — move the dot / re-segment / annotate. */
export const patchKraljicPositionSchema = z
    .object({
    categoryId: uuidSchema.nullable().optional(),
    supplyRisk: z.number().min(0).max(100).optional(),
    profitImpact: z.number().min(0).max(100).optional(),
    segment: kraljicSegmentSchema.optional(),
    rationale: z.string().trim().max(500).nullable().optional(),
})
    .strict();
//# sourceMappingURL=kraljic.js.map